import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";

export const useHeartbeat = () => {
  return useApiMutation<void, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Provider.HEARTBEAT,
      mutationFn: async () => {
        await axiosInstance.patch("/new-api/providers/heartbeat");
      },
    },
  });
};
